/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Whether the banner blocks user action until acknowledged, or is passively available in the notification center
 * @export
 */
export const VwbSystemNotificationType = {
    BLOCKING: 'BLOCKING',
    PASSIVE: 'PASSIVE'
} as const;
export type VwbSystemNotificationType = typeof VwbSystemNotificationType[keyof typeof VwbSystemNotificationType];


export function VwbSystemNotificationTypeFromJSON(json: any): VwbSystemNotificationType {
    return VwbSystemNotificationTypeFromJSONTyped(json, false);
}

export function VwbSystemNotificationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VwbSystemNotificationType {
    return json as VwbSystemNotificationType;
}

export function VwbSystemNotificationTypeToJSON(value?: VwbSystemNotificationType | null): any {
    return value as any;
}

